<template>
	<div class="investmentClues" data-title="产业投资窗口">
		<leftnav class="fl" :mkcode="curWebsite.type == 5 || curWebsite.type == 6 ?'T':'C'" itemcode="C-CYTZCK"></leftnav> 
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox " style="padding-bottom: 5px;">
					<div class="right_boxtitle">
						<span class="fl right_title" v-if="curWebsite.type != 5 && curWebsite.type != 6">{{curWebsite.keyword}}{{curWebsite.type == 2 ?'':'线索'}}</span>
						<span class="fl right_title" v-if="curWebsite.type == 5 || curWebsite.type == 6">{{curWebsite.type == 5 ? '投资':"产业"}}动态</span>
						<cluetips v-if="curWebsite.type != 5 && curWebsite.type != 6"></cluetips>
						<span class="fr showechart-c6" @click="showechart=!showechart">{{showechart?'隐藏':'查看'}}图表</span>
						<video-teaching :type="3" seat="top"></video-teaching>
					</div>
					<!-- 筛选项开始 --> 
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<ClueNav tabCode="cytzck" v-if="curWebsite.type != 5 && curWebsite.type != 6"></ClueNav>
							<dynamicNavTZ code="cytzck" v-if="curWebsite.type == 5 || curWebsite.type == 6"></dynamicNavTZ> 
						</div>
						<dl class="opport-screen bdbe">
							<dt class="fl">重点产业</dt>
							<dd class="fl">
								<span :class="{'a-screen':true,'current':notionCode == item.value}"
									v-for="(item,i) in hotnotionlist" :key="i" @click="getnotioncode(item,1)">{{item.label}}</span>
							</dd>
						</dl> 
						<dl class="opport-screen bdbe">
							<dt class="fl">产业分布</dt>
							<dd class="fl">
								<span :class="{'a-screen':true,'current':industryType == item.value}" v-for="(item,i) in industryArea" :key="'F'+i" @click="toggleIndustryArea(item)">{{item.label}}</span>
							</dd>
						</dl>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 柱状图 概念企业数量 -->
				<div class="fixedEchartmap" v-show="showechart">
					<!-- <h4 class="fl">{{notiontext}}-全国重点城市分布图</h4> -->
					<div id="fixedEchartMap"></div>
					<div id="fixedEchartBar"></div><span class="closebtn" @click="showechart=false"></span>
				</div>
				<!-- 表格内容开始 -->
				<div class="whitebox columnbox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<!-- {{industryType == 1 ? '家':'个'}}{{industryAreaName}} -->
						<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
					</div>
					<!-- 多维度分数筛选 -->
				<!-- 	<ul class="dimensionScreen oh w95mg" v-show="dimensionList.length>0">
						<li :class="orderField == list.type ?'fl current ':'fl '"   v-for="(list,index) in dimensionList" @click="tablesort(list.type);"><span
									:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span><span
								:class="orderType == 1?'timesorticon up':'timesorticon down'"></span></li>
					</ul> -->
					<div class="enterprise_list_box" >
						<!-- 企业列表 全部企业表头 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="enterpristlist.length>0 && industryType == 1">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>投资力度</th>
								<th>编辑</th>
							</tr>
							<tr v-for="(list,index) in enterpristlist" :key="index">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,9,'',curindex)">
									{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="(item,i) in list.notionlist" :key="'nontion'+i"
										@click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name,'all')">{{item.name}}</span>
								</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="(item,i) in list.taglist" :key="'tag'+i"
										@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name,'all')">{{item.name}}{{item.count}}</span>
								</td>
								<td>{{list.area}}</td>
								<td>{{list.zs100000}}</td>
								<td>{{list.zs200000}}</td>
								<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
							</tr>
						</table>
					<!-- 投资项目动态列表 -->
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="investList.length>0 && industryType == 2">
						<tr>
							<th>排名</th>
							<th>公司名称</th>
							<th>项目名称</th>
							<th>投资来源地</th>
							<th>行业</th>
							<!-- <th>概念</th> -->
							<th>投资地点</th>
							<th  v-for="(list,index) in industryArea[1].orderlist" :key="'indust'+index">
								<div @click="tablesort('industry',list.type);"  :class="industryorderField == list.type?'td_sortname current':'td_sortname'">
									<span	:class="industryorderField == list.type ?'sortname current ':'sortname '">{{list.name}}</span><span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
								</div> 
								</th>
						</tr>
						<tr v-for="(list,index) in investList" :key="'invest'+index">
								<td>{{(page-1)*pageSize+index+1}}</td>
							<td>
								<span class="fwb curp" v-if="list.stockCode!=''"  @click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</span>
								<span v-if="list.stockCode==''">{{list.shortName}}</span>
								
							</td>
							<td style="width:200px;"><span >{{list.projectName}}</span></td>
							<td>{{list.source}}</td>
							<td>{{list.industry}}</td>
							<!-- <td>{{list.notion}}</td> -->
							<td>{{list.area}}</td>
							<td>{{list.money}}{{list.unit}}</td>
							<td>{{list.date}}</td> 
						</tr>  
					</table>
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="landList.length>0 && industryType == 3">
						<tr>
							<th>排名</th>
							<th>行政区</th>
							<th>项目名称</th>
							<th>
							<div @click="tablesort('land',1);"  :class="landorderField == 1?'td_sortname current':'td_sortname'">
								<span	:class="landorderField == 1 ?'sortname current ':'sortname '">总面积(亩)</span><span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
							</div> 
							</th> 
							<th>土地用途</th>
							<th style="line-height: 20px;padding:10px 0; ">土地使用权人<br/>(项目公司)</th>
							<th>投资主体</th>
							<th>投资来源地</th>
							<th>
							<div @click="tablesort('land',3);"  :class="landorderField == 3?'td_sortname current':'td_sortname'">
								<span	:class="landorderField == 3 ?'sortname current ':'sortname '">日期</span><span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
							</div> 
							</th> 
						</tr>
						<tr v-for="(list,index) in landList" :key="'land'+index">
							<td>{{(page-1)*pageSize+index+1}}</td>
							<td>{{list.area}}</td>
							<td style="width: 120px;">{{list.projectName}}</td>
							<td>{{list.size}}{{list.sizeUnit}}</td>
							<td>{{list.purpose}}</td>
							<td style="width: 110px;">
								<span class="curp" v-if="list.stockCode!=''"  @click="routerlinkid('/enterprises',list.stockCode)">{{list.owner}}</span>
								<span v-if="list.stockCode==''">{{list.owner}}</span> 
							</td>
							<td style="width: 110px;">
								<span class="curp" v-if="list.sourceStockCode!=''"  @click="routerlinkid('/enterprises',list.sourceStockCode)">{{list.sourceEnterprise}}</span>
								<span v-if="list.sourceStockCode==''">{{list.sourceEnterprise}}</span> 
							</td> 
							<td>{{list.sourceArea}}</td>
							<td>{{list.time}}</td> 
						</tr>  
					</table>
					
					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		dataInJs
	} from "../../utils/city.js";
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'industryInvestmentWindow',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: "产业投资窗口",searchtype: 11, //线索类型 2以商招商 1本省投资概率 3关键融资 4热点产业企业 5.重城重产 
				userdata:{},curWebsite:this.$api.getWebsiteType(),  
				showechart: true, 
				notionCode: "A0201",
				notiontext: "新能源汽车",
				hotnotionlist: [
					// {value: "B0301",label: "酒"},
					{value: "A0201",label: "新能源汽车"},
					{value: "A0301",label: "半导体"}, 
					{value: "A0504",label: "储能"}, 
					{value: "A0505",label: "氢能源"},
					{value: "A0308",label: "人工智能"}, 
				], 
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序 
				industryorderField:0,
				landorderField:0,
				// 排序，投资项目：1=金额，2=时间； 拿地项目：1=面积，2=金额，3=时间
				dimensionList: [], 
				industryType:1,industryAreaName:"企业",
				industryArea:[{ 
						value: 1,
						label: "企业",
						orderlist:[],
					}, {
						value: 2,
						label: "投资项目",
						orderlist:[ {name: '金额',type: 1},{name: '时间',type: 2}],
					}, {
						value: 3,
						label: "拿地项目",
						orderlist:[ {name: '面积',type: 1},{name: '金额',type: 2},{name: '时间',type: 3}],
					},],
				hotnotionlisttr:"&高端装备&汽车产业&新一代信息技术&新材料&新能源&生物医药&",
				notionlistApi:[],//api后台概念数据
				hotnotionchildren:[], 
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"], 
				flages: true,   
				cityname: "北京市",
				enterpristlist: [],//企业
				investList: [],//投资项目
				landList: [],//拿地项目
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数 
				totalPage: 1,
				maxPage: 10, //最大页数  
				areadata: dataInJs(), //省份城市数据
				
				// ,{name:'控制企业数量',type:10},{name:'专利数量',type:11},
			}
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var _this = this;
			this.userdata = this.getuseriformation();

		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			// this.getapiNotionlist();
			this.getcompanylist(1, 'notion');
		},
		methods: {
			//切换产业分布 将order排序值设为0 更换order列表
			toggleIndustryArea(data){
				this.industryType = data.value;
				this.industryAreaName = data.label;
				this.orderField=0;
			 this.dimensionList=data.orderlist;
				this.getcompanylist();
			}, 
			//热门产业点击
			getnotioncode(list,type) {
				if (list.code == this.notionCode) {
					return;
				} 
				this.notionCode = list.value;
				this.notiontext = list.label;  
				this.getcompanylist(1, 'notion');
			}, 
			pageHandler: function(page) { 
				this.getcompanylist(page);  
			},
			//时间/分数升降序
			tablesort(type,field) {
				this.orderField=field;
				if(type == 'industry'){ 
					this.industryorderField=field;
				}else if(type == 'land'){ 
					this.landorderField=field;
				} 
				this.getcompanylist();
			},
			getcompanylist(page, type) {
				this.bus.$emit('loading', true);
				// console.log('getcompanylist');
			this.page=page?page:1;
			type='notion';
				var _this = this;
				//获取企业列表
				var notionja = this.splicing('notionCode',this.notionCode);//
				var indType = this.splicing('indType', this.industryType);
				var orderId = this.splicing('order', this.orderField); 
				var ajaxurl = this.$api.cyl.investclue.IndustryInvestmentWindow()+'?&page=' + this.page + indType  + orderId + notionja;
				console.log(ajaxurl);
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('省份城市列表',res.data)
					var citycountlist = res.data.cityList.city;
					if (res.data.success) {  
								// _this.allcitylist[0].count = res.data.totalRecord;
							// var sdt = _this.citynumsort(citycountlist);
								// var sdt=citycountlist;
							// _this.hotcitylist = _this.allcitylist.concat(sdt); 
							_this.chianmapFun('fixedEchartMap',citycountlist);
							_this.rankFun('fixedEchartBar',citycountlist.splice(0,10)); 
							_this.flages = false;
						 
						console.log('获取'+_this.industryAreaName+'列表', res.data);
					 
						if(_this.industryType == 1){
								_this.enterpristlist = res.data.list;
							//企业表头列表
							for (var i = 0; i < res.data.list.length; i++) {
								_this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this
									.enterpristlist[i].tagCode);
								_this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion,
									_this.enterpristlist[i].notionCode);
							}
						}else if(_this.industryType == 2){
							//投资项目表头列表
							_this.investList=res.data.list;
						}else if (_this.industryType == 3){
							//拿地项目表头列表
							_this.landList=res.data.list;
						}
						

						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize;
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//将重点城市数量从省级一下剥夺出来
			citynumsort(data) {
				let arr = [];
				for (var i = 0; i < data.length; i++) {
					if (data[i].name.indexOf('市') > 0) {
						arr.push({
							name: data[i].name,
							id: data[i].id,
							count: data[i].count,
						})
					} else {
						var arr1 = data[i].children;
						for (var d = 0; d < arr1.length; d++) {
							arr.push({
								name: arr1[d].name,
								id: arr1[d].id,
								count: arr1[d].count,
							})
						}
					}
				} 
				let arr2 = [];
				// 将需要排序的 key, 按照 "从大到小" 进行排列
				let sortKeys = Object.keys(arr).sort((a, b) => {
					return arr[b].count - arr[a].count;
				})
				// 循环排列好的 key, 重新组成一个新的数组
				for (var sortIndex in sortKeys) {
					arr2.push(arr[sortKeys[sortIndex]])
				}
				return arr2.slice(0, 20);
			},
			//弹出图表 概念企业数量排名
			rankFun(el, data) {
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var chart = echarts.init(document.getElementById(el));
				var _this = this,
					xline = [],
					seriesline = [];
				var datalen = data.length - 1;
				for (var i = 0; i < data.length; i++) {
					xline.push(data[datalen - i].name);
					seriesline.push(data[datalen - i].count);
				};
				// console.log(data,xline,seriesline)
				var option = {
					title: {
						// text:_this.cityname+'重点产业',
						text: '',
						right: 0,
						bottom: 20,
						textStyle: {
							color: '#333',
							fontSize: 16
						}
					},
					tooltip: {
						formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{b}：{c}"
					},
					color: _this.colors,
					grid: { containLabel: true },
					label: {
						show: true,
						position: 'right',
						valueAnimation: true,
						color: '#333',
						formatter: '{@score}'
					},
					xAxis: {
						type: 'value',
						axisTick: {
							show: false
						},
						boundaryGap: [0, 0.01],
						splitLine: {
							show: true
						},
						axisLabel: {
							fontSize: 13,
							color: '#333'
						}
					},
					yAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: true
						},
						data: xline,
						axisLabel: {
							fontSize: 13,
							color: '#333'
						}
					},
					series: [{
						data: seriesline,
						type: 'bar',
						barWidth: 10,
					}]
				};
				chart.setOption(option);

			},
			//拿地项目地图分布
			chianmapFun(el, data) {
				console.log(this.notiontext,'chianmapFun')
				var myChart = echarts.init(document.getElementById(el)); 
				var loadedDataURL = 'map/china.json';
				// 注意引入版本 
				var geoCoordMap = this.$geoJson;
				data=data.slice(0,20); 
				var _this=this;
				$.getJSON(loadedDataURL, function(geoJson) { 
					// 注册地图名字(tongren)和数据(geoJson) 
					echarts.registerMap('china', geoJson);
					var scaData = [],
						maptitle = ''; 
					maptitle = _this.notiontext+'-'+_this.industryAreaName+'全国分布'; 
					for (var i = 0; i < data.length; i++) { 
						var geoCoord = geoCoordMap[data[i].name]; 
						// console.log(geoCoord)
						if (geoCoord) { 
							scaData.push({
								name: data[i].name,
								value: geoCoord.concat(data[i].count), //新值= 坐标+旧值；
								id: data[i].id,
							});
						}else{
							console.log(data[i].name,data[i].count);
						}
					}

					var option = {
						backgroundColor: '#fff',
						title: {
							text: maptitle,
							left: 'center',
							top: 20,
							textStyle: {
								color: '#666',
								fontSize: 16
							}
						},
						tooltip: { //提示框组件
							trigger: 'item',
							formatter: function(params) {
								// console.log(params)
								return params.name;
							},
							show: true,
						},

						legend: { //图例
							orient: 'vertical',
							show: false,
							y: 'bottom',
							x: 'right',
						},
						geo: {
							map: "china",
							silent: true,
							// layoutCenter: ['49%', '49%'],
							layoutSize: '100%',
							roam: false,
							center: [105.87, 38],
							zoom: 1,
							label: {
								show: true,
								textStyle: {
									color: '#fff'
								}
							},
							itemStyle: {
								normal: {
									areaColor: "#2e579d",
									borderColor: "#fff"
								},
								emphasis: {
									areaColor: "#fff"
								}
							}
						},
						series: [{
							name: '',
							type: 'effectScatter',
							coordinateSystem: 'geo',
							data: scaData, //选取从 start 到数组结尾的所有元素，该方法并不会修改数组，而是返回一个子数组 
							symbolSize: function(val) {
								var ddd = 10,
									val1 = val[2];
								if (val1 < 1000 && val1 > 500) {
									ddd = 10 + parseInt(val1 / 300);
								} else if (val1 > 1000) {
									var snum = parseInt(val1 / 1000);
									ddd = 15 + snum;
								}
								// console.log(val,ddd);
								return ddd;
							},
							showEffectOn: 'render',
							rippleEffect: {
								brushType: 'stroke'
							},
							tooltip: {
								show: true,
								formatter: function() {},
							},
							hoverAnimation: true,
							label: {
								normal: {
									formatter: '{b}:{@2}',
									position: 'right',
									show: false
								},
								emphasis: {
									show: true
								}
							},
							itemStyle: {
								normal: {
									color: '#f4e925',
									shadowBlur: 10,
									shadowColor: '#333'
								}
							},
							zlevel: 1
						}, ]
					};

					option.series[0].tooltip.formatter = function(params) { 
						return '<span style="font-size:15px;line-height:20px;margin-bottom:5px">'+params.name+':'+params.value[2]+'</span>';
					} 
					myChart.setOption(option);

				})
			}
		},
	}
</script>

<style>
	/* 提示框箭头 */
	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
		border-top-color: #E0E8F9;
	}

	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
		border-top-color: #E0E8F9;
	}

	/* 提示框背景色 */
	.atooltip {
		background: #E0E8F9 !important;
	}
</style>
